import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_OPEN_SERVER;

export const getSecretKey = async (token) => {
  const response = await axios.get(`${API_BASE}/v1/affiliate/portal/auth/secret-key`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data; // data = { success: true, data: { secretKey, stime } }
};


export const loginAPI = async ({ username, password }) => {
  const response = await axios.post(`${API_BASE}/v1/affiliate/portal/auth/token`, {
    clientType: "portal",
    credentials: { username, password },
  });
  return response.data;
};